<template
    ><div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.name ? activeCompany.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Legal type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeCompany.legal_type
                        ? activeCompany.legal_type.charAt(0).toUpperCase() + activeCompany.legal_type.slice(1)
                        : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Identification code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.identification_code ? activeCompany.identification_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "EU vat number" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.eu_vat_number ? activeCompany.eu_vat_number : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.country ? activeCompany.country : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Homepage URL" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.client_url ? activeCompany.client_url : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Postback URL" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.postback_url ? activeCompany.postback_url : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Invoice payer" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ getCompanyName(activeCompany.invoice_payer_id) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "AIS package" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.ais_package ? formatAisPackage(activeCompany.ais_package) : '-' }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {companyMixin} from "@/mixins/company-mixin";

export default {
    name: "general-info-view-tab",
    mixins: [companyMixin],
    computed: {
        ...mapState(["activeCompany", "companies"])
    },
    methods: {
        getCompanyName(id){
            const company = this.companies.find(c => c.id === id);
            if (company) return company.name;
            return "-";
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
